import { config, handleResponse } from '../../_helpers';

export const vesselUpdatesServices = {
    load,
    getVesselHeaderDetails,
    createVesselHeader,
    createVesselDetails,
    updateVesselDetails,
    deleteDetails,
    deleteHeaders,
};

function load(skip, take, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(search),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/VesselUpdates/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/VesselUpdates/loadVesselUpdateHeaderV1?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
}

function getVesselHeaderDetails(Vuid) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/VesselUpdates/getVesselHeaderDetails/${Vuid}`, requestOptions).then(handleResponse);
}

function createVesselHeader(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/VesselUpdates/CreateVesselHeader`, requestOptions).then(handleResponse);
}

function createVesselDetails(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/VesselUpdates/CreateVesselDetails`, requestOptions).then(handleResponse);
}

function updateVesselDetails(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/VesselUpdates/updateVesselDetails/${id}`, requestOptions).then(handleResponse);
}

function deleteDetails(id) {
    const requestOptions = {
        method: 'DELETE'
    };

    return fetch(`${config.apiUrl}/VesselUpdates/deleteDetails/${id}`, requestOptions).then(handleResponse);
}

function deleteHeaders(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify([id]),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/VesselUpdates/delete`, requestOptions).then(handleResponse);
}